<template>
  <div class="main-offer-card">
    <div class="summary-header">
      <div class="summary-title">
        <div class="summary-icon-complaints-details"></div>
        <div class="summary-text">
          {{ $t('complaintManagementDetails') }}
        </div>
      </div>
    </div>
    <div>
      <div class="tableContainerDetails complaint-details">
        <f7-row class="card-body">
          <f7-col>
            <div class="label-strong">
              {{ this.$t('complaintCode') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{ selectedComplaint.title }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">
              {{ this.$t('complaintRequester') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{
                  ComplaintDetails.nombreContacto ||
                  selectedComplaint.nombreContacto ||
                  ''
                }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">{{ this.$t('date') }}</div>
            <div class="item-title-bold value-text">
              <div>
                {{
                  selectedComplaint.created
                    ? `${selectedComplaint.created
                        .getDate()
                        .toString()
                        .padStart(2, '0')}/` +
                      `${(selectedComplaint.created.getMonth() + 1)
                        .toString()
                        .padStart(2, '0')}/` +
                      `${selectedComplaint.created.getFullYear()}`
                    : ''
                }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">{{ this.$t('origin') }}</div>
            <div class="item-title-bold value-text">
              <div>
                {{ selectedComplaint.translatedOrigin }}
              </div>
            </div>
          </f7-col>

          <f7-col v-if="complaintAgent">
            <div class="label-strong">
              {{ this.$t('complaintAgent') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{ complaintAgent }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">
              {{ this.$t('status') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{ selectedComplaint.translatedColorStatus }}
              </div>
            </div>
          </f7-col>
        </f7-row>

        <!-- Si el origen lo requiere, se muestran los campos de muestras -->
        <!-- v-if="
          complaintDetails.origen == 'Resultados de Ensayo' ||
          complaintDetails.origen == 'Petición del Cliente' ||
          complaintDetails.origen == 'Error Ingreso Muestra' ||
          complaintDetails.origen == 'Informe Incorrecto'
        " -->
        <!-- Actualmente en fase 1, se muestra solo si el campo tiene datos -->
        <f7-row
          v-if="ComplaintDetails.codigoMuestra"
          class="card-body"
        >
          <f7-col>
            <div class="label-strong">
              {{ this.$t('agronomySample.summary.sampleCode') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{ ComplaintDetails.codigoMuestra }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">
              {{ this.$t('agronomySample.summary.sampleType') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{ ComplaintDetails.tipoMuestra }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">{{ this.$t('PNT') }}</div>
            <div class="item-title-bold value-text">
              <div>
                {{ ComplaintDetails.pnt }}
              </div>
            </div>
          </f7-col>

          <f7-col>
            <div class="label-strong">
              {{ this.$t('alert.parameters') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                <!-- Elimino los corchetes y comillas, si hubiera -->
                {{
                  JSON.parse(ComplaintDetails.parametro).join(', ')
                }}
              </div>
            </div>
          </f7-col>
        </f7-row>

        <f7-row class="card-body">
          <f7-col>
            <div class="label-strong">
              {{ this.$t('agronomySample.summary.description') }}
            </div>
            <div class="item-title-bold value-text">
              <div>
                {{ ComplaintDetails.descripcionQueja }}
              </div>
            </div>
          </f7-col>
        </f7-row>
      </div>
      <div class="complaint-file-details">
        <!-- Si hay ZIP de archivos adjuntos, se permite descarga, si no se muestra el mensaje -->
        <f7-row class="card-body">
          <f7-col v-if="complaintFilesLoading || ComplaintFiles[0]">
            <div class="label-strong icon-label">
              <div class="icon-complaint-details-files"></div>
              <span>{{ $t('complaintFiles') }}</span>
            </div>
            <div class="item-title-bold value-text icon-text">
              <div
                v-if="complaintFilesLoading"
                class="complaint-download-loading"
              >
                <f7-preloader :size="24"></f7-preloader>
                <span>{{ $t('loading') }}</span>
              </div>
              <div v-else-if="ComplaintFiles[0]">
                <div v-if="!ComplaintFiles[0].tieneArchivos">
                  {{ $t('complaintFilesNoneMessage') }}
                </div>

                <div v-else class="mt-2">
                  <a
                    href="#"
                    @click.prevent="onDownloadClick('files')"
                    class="file-name"
                  >
                    <i class="dx-icon-download"></i>
                    {{ ComplaintFiles[0].filename || 'archivo.zip' }}
                  </a>
                </div>
              </div>
            </div>
          </f7-col>
          <!-- Si hay ZIP de informe de contestación, se permite descarga, si no se muestra el mensaje -->
          <f7-col v-if="complaintReportLoading || ComplaintReport[0]">
            <div class="label-strong icon-label">
              <div class="icon-complaint-details-report"></div>
              <span>{{ $t('complaintReport') }}</span>
            </div>
            <div class="item-title-bold value-text icon-text">
              <div
                v-if="complaintReportLoading"
                class="complaint-download-loading"
              >
                <f7-preloader :size="24"></f7-preloader>
                <span>{{ $t('loading') }}</span>
              </div>
              <div v-else-if="ComplaintReport[0]">
                <div v-if="!ComplaintReport[0].tieneArchivos">
                  {{ $t('complaintReportNoneMessage') }}
                </div>

                <div v-else class="mt-2">
                  <a
                    href="#"
                    @click.prevent="onDownloadClick('report')"
                    class="file-name"
                  >
                    <i class="dx-icon-download"></i>
                    {{ ComplaintReport[0].filename || 'archivo.zip' }}
                  </a>
                </div>
              </div>
            </div>
          </f7-col>
        </f7-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'ComplaintDetails',
  components: {},
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      origenCodMuestra: true,
    };
  },
  computed: {
    ComplaintDetails() {
      return this.complaintDetails;
    },
    ComplaintFiles() {
      return this.complaintFiles;
    },
    ComplaintReport() {
      return this.complaintReport;
    },
    ...mapState('complaintManagement', [
      'complaintAgent',
      'complaintDetails',
      'complaintFiles',
      'complaintFilesLoading',
      'complaintReport',
      'complaintReportLoading',
      'selectedComplaint',
    ]),
  },
  methods: {
    // Método de descarga de archivos zip, indicando tipo 'files' o 'report'
    async onDownloadClick(type) {
      try {
        this.notificationMessage = this.$t('downloading');

        const source =
          type === 'report'
            ? this.ComplaintReport[0]
            : this.ComplaintFiles[0];

        if (!source?.tieneArchivos) {
          this.notificationMessage =
            source?.mensaje || this.$t('noFilesFound');
          return;
        }

        const b64 = source.fileBase64;
        const filename =
          source.filename ||
          (type === 'report'
            ? 'informe-incidencia.zip'
            : 'archivos-incidencia.zip');

        const link = document.createElement('a');
        link.href = `data:application/zip;base64,${b64}`;
        link.download = filename;
        link.click();

        URL.revokeObjectURL(link.href);
        this.notificationMessage = this.$t('downloadedFile');
      } catch (e) {
        this.notificationMessage = '';
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(e.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        setTimeout(() => {
          this.notificationMessage = '';
        }, 2000);
      }
    },
  },
};
</script>

<style>
.complaint-details {
  margin: 32px 0 0px;
}
.complaint-file-details {
  margin: 32px 0 15px;
  padding: 16px 16px 6px;
  align-self: stretch;
  border-radius: 10px;
  background: var(--Primary-Blue-10, #ebf2fa);
  border: 1px solid var(--Neutral-20, #e0e0e0) !important; /* un gris suave para el borde */
}
.icon-text {
  padding: 10px 10px 0px;
}
.complaint-download-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
}
</style>
